// RoleGuard - no Navigate needed, renders inline access denied
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '../stores/authStore'

interface RoleGuardProps {
  allowedRoles: string[]
  children: React.ReactNode
}

export default function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const { user } = useAuthStore()
  const { t } = useTranslation()

  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          {t('common.accessDenied')}
        </Typography>
        <Typography color="text.secondary">
          {t('common.adminRequired')}
        </Typography>
      </Box>
    )
  }

  return <>{children}</>
}
